/* eslint-disable no-unused-vars */
import {
  get as getAxios,
  put as putAxios,
  post as postAxios,
} from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;
const PAGE_SIZE = 5;

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });

export default class Announcement {
  static getAnnouncementCycle(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = get(`/api/announcements`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Announcement.getAnnouncementCycle.cancel = request.cancel;
    return request;
  }

  static initiateAnnouncementCycle(data) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/announcements`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    Announcement.initiateAnnouncementCycle.cancel = request.cancel;
    return request;
  }

  static updateAnnouncement(data, announcementId) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/announcements/${announcementId}`, {
      data,
      accessToken: accessTokenFromLocal,
    });
    Announcement.updateAnnouncement.cancel = request.cancel;
    return request;
  }
}
